<template>
    <full-calendar :options="calendarOptions"/>
</template>

<script>
import Api from "../services/Api";
import ModalBus from "../eventBus";
import EventModal from "./Modals/EventModal";

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'

export default {
    components: {FullCalendar},
    data() {
        const isMobile = window.innerWidth < 800;
        const headerToolbar = isMobile ? {
            left: 'title',
            right: 'prev,next',
        } : {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,listMonth',
        };

        return {
            calendarOptions: {
                height: 700,
                plugins: [dayGridPlugin, listPlugin],
                initialView: isMobile ? 'listMonth' : 'dayGridMonth',
                headerToolbar,
                locale: 'fr',
                eventClick: this.handleClick,
                eventBackgroundColor: 'transparent',
                eventBorderColor: 'transparent',
                displayEventTime: false,
                eventTextColor:'#333333',
                eventDisplay: 'block',
                views: {
                  list:{
                      noEventsContent: 'Aucun événement ce mois-ci',
                  }
                },
                buttonText: {
                    today: 'Aujourd\'hui',
                    month: 'Mois',
                    week: 'Semaine',
                    day: 'Jour',
                    list: 'Liste'
                },
                events: []
            }
        };
    },
    async created() {
        const {data} = await Api.get('/events');
        this.events = data;
        this.calendarOptions = {
            ...this.calendarOptions,
            events: data.map((event) => ({
                id: event.id,
                title: event.title,
                start: event.start_at,
                end: event.end_at,
            }))
        }
    },
    methods: {
        handleClick(info) {
            const event = this.events.find((event) => event.id === info.event.id);
            if (event) {
                ModalBus.open({component: EventModal, props: {event}})
            }
        }
    }
};
</script>


<style>
.fc-event-title {
    font-weight: 500;
    padding: 3px 5px !important;
}

.fc-event-main-frame{
    cursor: pointer;
}

.fc-view-harness {
    background: #fff !important;
}

.fc-view-harness a {
    color: #333 !important;
}

.fc-event-main {
    background: #ffee00 !important;
    border-radius: 5px !important;
}
</style>
